export enum StatusCodes {
  READYTOCAST = "U",
  ARRIVE = "C",
  OPEN = "O",
  CLOSE = "P",
  END = "F",
}
